<template>
  <el-row class="login-footer" type="flex" justify="center">
    <el-col :xs="24" :sm="20" :md="20" :lg="22" :xl="21">
      <el-row type="flex" justify="space-around">
        <el-col :xs="24" :md="24">
          <img :src="footerLogo" />
          <div class="footer__logo-info">共建跨境电商行业共生型生态云</div>
        </el-col>
        <el-col :xs="24" :md="24" class="footer__dl">
          <dl>
            <dt>联系我们</dt>
            <dd>客服电话：400 - 1668 - 638</dd>
            <dd>联 系 人：Vera</dd>
            <dd>联系方式：139 - 2866 - 1367</dd>
            <dd>联系邮箱：vera@gpsl.hk</dd>
          </dl>
        </el-col>
        <el-col class="footer__qr">
          <img src="https://img.oceanz.cn/qrcode.jpg" />
          <div class="footer__qr__info">
            扫一扫立即关注<br />更多信息尽在指掌
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      footerLogo: "https://img.oceanz.cn/footer_logo.png",
    };
  },
};
</script>

<style lang="scss">
.login-footer {
  margin-top: 119px;
  padding: 35px 0;
  background: #0f1533;
  .footer__logo {
    &-info {
      min-width: 347px;
      margin-top: 23px;
      font-family: MicrosoftYaHei;
      font-size: 24px;
      color: rgb(255, 255, 255);
    }
  }
  .footer__dl {
    min-width: 181px;
    max-width: 300px;
    color: #fff;
    dl {
      margin: 0;
    }
    dt {
      font-family: SourceHanSansSC;
      height: 16px;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 30px;
    }
    dd {
      font-family: Arial;
      margin-left: 0;
      margin-bottom: 15px;
      height: 14px;
      font-size: 14px;
    }
  }
  .footer__qr {
    width: 120px;
    &__info {
      margin-top: 24px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      line-height: 1.57;
      text-align: left;
      color: rgb(255, 255, 255);
    }
  }
}
</style>
